import { Button, Col, DatePicker, Form, Input, Modal, Row, Select } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getAllIssueCountry } from '../../../redux/rtk/features/masters/issueCountrySlice';
import { addSensitiveDetails, loadSingleStaff, updateSensitiveDetails } from '../../../redux/rtk/features/user/userSlice';
import getCompanyIdFromToken from '../../../utils/getCompanyIdFromToken';
import BtnEditSvg from '../Button/btnEditSvg';

const SensitiveDetailPopup = ({ data }) => {
  const { Option } = Select;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const companyId = getCompanyIdFromToken();
  const { id: user_id } = useParams();
  const navigate = useNavigate();
  const issueCountry = useSelector((state) => state.issueCountry?.list);

  const [passportNumber, setPassportNumber] = useState(data?.passportNumber || '');
  const [licenseNumber, setLicenseNumber] = useState(data?.licenseNumber || '');
  const [visaNumber, setVisaNumber] = useState(data?.visaNumber || '');

  useEffect(() => {
    dispatch(getAllIssueCountry())
  }, []);

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        ...data,
        passportExpiryDate: data.passportExpiryDate ? dayjs(data.passportExpiryDate) : null,
        DLExpiryDate: data.DLExpiryDate ? dayjs(data.DLExpiryDate) : null,
        visaExpiryDate: data.visaExpiryDate ? dayjs(data.visaExpiryDate) : null,
      });
      setPassportNumber(data.passportNumber || '');
      setLicenseNumber(data.licenseNumber || '');
      setVisaNumber(data.visaNumber || '');
    }
  }, [data, form]);
  console.log("data", data);
  const handlePassportChange = (e) => {
    setPassportNumber(e.target.value);
    form.setFieldsValue({ passportExpiryDate: null }); // Reset expiry date when passport number changes
  };

  const handleLicenseChange = (e) => {
    setLicenseNumber(e.target.value);
    form.setFieldsValue({ DLExpiryDate: null }); // Reset expiry date when license number changes
  };

  const handleVisaChange = (e) => {
    setVisaNumber(e.target.value);
    form.setFieldsValue({ visaExpiryDate: null }); // Reset expiry date when visa number changes
  };

  const onFinish = async (values) => {
    const payload = {
      ...values,
      userId: parseInt(user_id), // Make sure user_id is a number
      company_id: parseInt(companyId), // Make sure companyId is a number
      passportExpiryDate: values.passportExpiryDate ? values.passportExpiryDate.format('YYYY-MM-DD') : null,
      DLExpiryDate: values.DLExpiryDate ? values.DLExpiryDate.format('YYYY-MM-DD') : null,
      visaExpiryDate: values.visaExpiryDate ? values.visaExpiryDate.format('YYYY-MM-DD') : null,
      status: true,
      // Parse the country IDs if they exist
      issueCountry: values.issueCountry ? parseInt(values.issueCountry) : undefined,
      DLIssueCountry: values.DLIssueCountry ? parseInt(values.DLIssueCountry) : undefined
    };

    try {
      if (data?.id) {
        await dispatch(updateSensitiveDetails({ id: data.id, values: payload }));
      } else {
        await dispatch(addSensitiveDetails(payload));
      }
      dispatch(loadSingleStaff(user_id));
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  return (
    <>
      <button onClick={() => setIsModalOpen(true)}>
        <BtnEditSvg size={30} />
      </button>
      <Modal
        width="70%"
        title="Update Sensitive Details"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="NI Number"
                name="NINumber"
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Tax Code"
                name="taxCode"
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                label="Passport Number"
                name="passportNumber"
              >
                <Input  value={passportNumber} onChange={handlePassportChange} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                style={{ marginBottom: "10px" }}
                label='Country of Issue (Passport)'
                name='issueCountry'
              >
                <Select
                  placeholder='Select Country'
                  showSearch
                  allowClear
                  size='middle'>
                  {issueCountry &&
                    issueCountry.map((issueCountry) => (
                      <Option key={issueCountry.id} value={issueCountry.id}>
                        {issueCountry.issueCountry}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Passport Expiry Date"
                name="passportExpiryDate"
                rules={passportNumber ? [{ required: true, message: 'Passport expiry date is required' }] : []}
              >
                <DatePicker style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                label="License Number"
                name="licenseNumber"
              >
                <Input value={licenseNumber} onChange={handleLicenseChange}/>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label="License Class"
                name="licenseClass"
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                style={{ marginBottom: "10px" }}
                label='Country of Issue (License)'
                name='DLIssueCountry'
                
              >
                <Select
                  placeholder='Select Country'
                  showSearch
                  allowClear
                  size='middle'>
                  {issueCountry &&
                    issueCountry.map((issueCountry) => (
                      <Option key={issueCountry.id} value={issueCountry.id}>
                        {issueCountry.issueCountry}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label="DL Expiry Date"
                name="DLExpiryDate"
                rules={licenseNumber ? [{ required: true, message: 'License expiry date is required' }] : []}>
                <DatePicker style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Visa Number"
                name="visaNumber"
              >
                <Input  value={visaNumber} onChange={handleVisaChange}/>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Visa Expiry Date"
                name="visaExpiryDate"
                rules={visaNumber ? [{ required: true, message: 'Visa expiry date is required' }] : []}
              >
                <DatePicker style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Update Details
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default SensitiveDetailPopup;